export const DYNAMIC_MENU_UID = "372b673e-8c83-45c7-be67-803a13daf3dd"
export const SERVICE_DEFINITION_IMPORT_UID = "24d92972-07cb-4204-957a-968b3bbe2058"

export const SERVICE_DEFINITION_GEN_CERT_BTN_UID = "93c8bae4-0248-4f4e-9c0b-5805772cb441"
export const SERVICE_DEFINITION_REISSUE_BTN_UID = "2aad83eb-796f-4b50-9649-456262d099b4"
export const SERVICE_DEFINITION_GEN_KEY_BTN_UID = "f74bed7c-913a-4f91-9a3d-9713eb39a733"
export const SERVICE_DEFINITION_DL_CSR_UID = "2172b91d-6124-4c3b-bcf1-36bcad0629f8"
export const SERVICE_DEFINITION_IMP_CERT_BTN_UID = "24d92972-07cb-4204-957a-968b3bbe2058"

export const FORM_TYPE_UID_CA_DATA = "38402bc7-dc2d-4d2f-b7a5-217fdeeceb9b"